import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  finalScore: number;
  highScore: number;
  isNewRecord: boolean;
  isPerfect: boolean;
  onReplay: () => void;
}

export const FinalScoreModal = ({ 
  open,
  onOpenChange,
  finalScore, 
  highScore, 
  isNewRecord, 
  isPerfect,
  onReplay, 
}: Props) => {
  const handleReplay = () => {
    onReplay();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {/* Don't allow closing the modal by clicking outside or pressing Escape until user explicitly clicks the replay button */}
      <DialogContent 
        className="max-w-md p-8 [&>button]:hidden"
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader className="pb-2">
          <DialogTitle className="text-center text-3xl font-bold">
            {isPerfect ? '🎉 Perfect Run!' : 'Practice Complete!'}
          </DialogTitle>
        </DialogHeader>

        <div className="text-center">
          <div className="text-5xl font-bold text-blue-500 mb-2">
            {finalScore.toLocaleString()}
          </div>
          
          {isNewRecord && (
            <div className="text-yellow-500 font-bold mb-4">
              🏆 NEW HIGH SCORE!
            </div>
          )}
          
          <div className="text-zinc-600 mb-6">
            High Score: {highScore.toLocaleString()}
          </div>
          
          <div className="flex gap-4">
            <button
              onClick={handleReplay}
              className="flex-1 bg-blue-500 text-white py-3 px-6 rounded hover:bg-blue-600 transition-colors"
            >
              Replay
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};